/**
 * Shared audit log formatting utilities
 */

/**
 * Parse a value that might be a JSON string array or already an array
 */
export function parseIndividualSetupArray(value: any): any[] | null {
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value !== "string") {
    return null;
  }
  try {
    const parsedValue = JSON.parse(value);
    return Array.isArray(parsedValue) ? parsedValue : null;
  } catch (error) {
    return null;
  }
}

/**
 * Check if a value is an individualSetup array of objects
 */
export function isIndividualSetupArray(itemKey: string, value: any): boolean {
  if (itemKey !== "individualSetup") {
    return false;
  }
  const individualSetupArray = parseIndividualSetupArray(value);
  if (!Array.isArray(individualSetupArray) || individualSetupArray.length === 0) {
    return false;
  }
  const firstNonNull = individualSetupArray.find(item => item !== null && item !== undefined);
  return (
    firstNonNull !== undefined &&
    typeof firstNonNull === "object" &&
    !Array.isArray(firstNonNull)
  );
}

/**
 * Escape HTML to prevent XSS
 */
function escapeHtml(text: string): string {
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}

/**
 * Format an individualSetup array as an HTML table
 */
export function formatIndividualSetupTable(value: any): string {
  const individualSetupArray = parseIndividualSetupArray(value);

  if (!individualSetupArray || individualSetupArray.length === 0) {
    return "";
  }

  const rows = individualSetupArray
    .filter(item => item !== null && item !== undefined)
    .map(item => {
      const identifier = escapeHtml(item.setupIdentifier || "");
      const setup = escapeHtml(item.setup || "");
      return `
        <tr>
          <td style="padding: 4px 8px; border: 1px solid #e0e0e0; width: 35%;">${identifier}</td>
          <td style="padding: 4px 8px; border: 1px solid #e0e0e0; width: 65%;">${setup}</td>
        </tr>
      `;
    })
    .join("");

  return `
    <table style="width: 100%; border-collapse: collapse; font-size: 0.875rem;">
      <thead>
        <tr style="background-color: #f5f5f5;">
          <th style="padding: 4px 8px; border: 1px solid #e0e0e0; text-align: left; font-weight: 600; width: 35%;">Setup Identifier</th>
          <th style="padding: 4px 8px; border: 1px solid #e0e0e0; text-align: left; font-weight: 600; width: 65%;">Setup</th>
        </tr>
      </thead>
      <tbody>
        ${rows}
      </tbody>
    </table>
  `;
}
